module.exports = __webpack_public_path__ + "h5/img/bott2.3f0821a9.jpg";